/* FATCUTPRESS Visual Manager — STEP 2
 * Track-to-visual routing and adapter lifecycle.
 * Player logic stays independent: tracks only provide a visualStyle key.
 */
(() => {
  'use strict';

  const registry = new Map();
  let activeTrack = null;
  let activeVisual = null;

  function normalizeVisualKey(value) {
    const key = String(value || '').trim();
    return key || 'default';
  }

  function registerVisual(key, adapter) {
    const visualKey = normalizeVisualKey(key);
    if (!adapter || typeof adapter !== 'object') return false;
    registry.set(visualKey, adapter);
    return true;
  }

  function unregisterVisual(key) {
    return registry.delete(normalizeVisualKey(key));
  }

  function getVisual(key) {
    return registry.get(normalizeVisualKey(key)) || null;
  }

  function resolveVisual(key) {
    const visualKey = normalizeVisualKey(key);
    return {
      key: visualKey,
      adapter: getVisual(visualKey) || getVisual('default')
    };
  }

  function activateVisual(nextVisual, track) {
    if (activeVisual?.adapter === nextVisual.adapter) {
      activeVisual = nextVisual;
      activeVisual.adapter?.update?.({ track, key: nextVisual.key });
      return;
    }

    activeVisual?.adapter?.deactivate?.({
      track: activeTrack,
      key: activeVisual.key
    });

    activeVisual = nextVisual;
    activeVisual.adapter?.activate?.({
      track,
      key: activeVisual.key
    });
  }

  function setTrack(track) {
    if (!track || typeof track !== 'object') return;

    const nextVisual = resolveVisual(track.visualStyle);
    activateVisual(nextVisual, track);
    activeTrack = track;

    window.dispatchEvent(new CustomEvent('fatcut:visual-track-ready', {
      detail: {
        track: activeTrack,
        visual: activeVisual
      }
    }));
  }

  function getState() {
    return {
      track: activeTrack,
      visual: activeVisual,
      registeredVisuals: Array.from(registry.keys())
    };
  }

  window.FATCUT_VISUAL_MANAGER = Object.freeze({
    registerVisual,
    unregisterVisual,
    getVisual,
    getState
  });

  const pendingVisuals = Array.isArray(window.FATCUT_PENDING_VISUALS)
    ? window.FATCUT_PENDING_VISUALS.splice(0)
    : [];
  pendingVisuals.forEach(({ key, adapter }) => {
    registerVisual(key, adapter);
  });

  window.addEventListener('fatcut:visual-register', event => {
    const detail = event.detail || {};
    if (!registerVisual(detail.key, detail.adapter)) return;
    if (activeTrack) setTrack(activeTrack);
  });

  window.addEventListener('fatcut:track-change', event => {
    setTrack(event.detail?.track || null);
  });
})();
